import { NavigationItem } from '../common/navigation';

/** The branch flags the sidebar reacts to. */
export interface NavBranchFlags {
  ehrEnabled?: boolean;
  newCalendar?: boolean;
  servicesRedesignEnabled?: boolean;
  payrollEnabled?: boolean;
}

/**
 * Which nav entries a branch sees, and where they point.
 *
 * A pure function rather than logic inside the component's constructor
 * `effect`, because the component cannot be instantiated in a test without the
 * store, the router and a dozen services — so the rules would go unverified.
 * They are exactly the rules that fail silently: a link that quietly does not
 * appear, or quietly points at the old screen.
 */
export function shapeNavigation(items: NavigationItem[], branch: NavBranchFlags): NavigationItem[] {
  const servicesRedesign = !!branch.servicesRedesignEnabled;

  return items
    .filter((menu) => {
      if (menu.id === 'ehealth' && !branch.ehrEnabled) {
        return false;
      }
      // `/bookinghub` has exactly one route and it redirects to the online
      // catalogue, which the merge folded into the services list. Left in, it
      // is a second door onto the same services — the old one.
      if (menu.id === 'bookinghub' && servicesRedesign) {
        return false;
      }
      return true;
    })
    .map((menuItem) => {
      // The redesigned screen has its own address, so the flag decides where
      // this link points rather than swapping two screens behind one URL.
      if (menuItem.id === 'services' && servicesRedesign) {
        return { ...menuItem, url: '/services/v2' };
      }
      return menuItem;
    })
    .map((menuItem) => ({
      ...menuItem,
      children: menuItem?.children
        // beaut-526. Once a branch is on payroll, the legacy salary screen
        // refuses to pay — SalaryService throws
        // PAYROLL_LEGACY_PAY_DISABLED_FOR_BRANCH rather than let the same
        // obligation be settled twice through two paths that cannot see each
        // other. Leaving the link up offers the operator the familiar door and
        // answers with a raw enum in a toast; the accrual screen beside it is
        // the one that works.
        ?.filter((item: NavigationItem) => !(item.id === 'salary' && branch.payrollEnabled))
        .map((item: NavigationItem) =>
          item.id === 'calendars_daily_new' && branch.newCalendar ? { ...item, show: true } : item,
        ),
    }));
}
